"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _boxModelSize = require("@site/pattern-library-utils/box-model-size");
var _density = require("@site/pattern-library-utils/density");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _waterfallItem = _interopRequireDefault(require("./waterfall-item"));
const RootContainer = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "RootContainer",
  class: "pl-r1cuv6qu"
});
const Container = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "Container",
  class: "pl-ct3nwia"
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-hwjneh2"
});
const HeadlineInner = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineInner",
  class: "pl-h9nun29"
});

/**
 * Waterfall Section component.
 * @module WaterfallSection
 *
 * @param {Object} props React props
 * @param {Array} props.sections Array of child
 * @param {String} props.layout Support Reverse Layout
 * @param {String} props.partial Partial Theme
 * @returns {React.ReactElement} Waterfall component
 * @public
 */
function WaterfallSection({
  sections,
  layout = 'default',
  _name,
  verticalMargin,
  verticalPadding,
  partial,
  ...headlineProps
}) {
  if (!sections) return null;
  return /*#__PURE__*/_react.default.createElement(RootContainer, {
    _name: _name,
    dataCy: "waterfall-section",
    partial: partial,
    verticalMargin: verticalMargin,
    verticalPadding: verticalPadding
  }, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, null, /*#__PURE__*/_react.default.createElement(HeadlineInner, {
    "data-layout": layout,
    "data-cy": "headline-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
    eyebrowTag: "h2"
  }, headlineProps)))), sections && /*#__PURE__*/_react.default.createElement(Container, {
    "data-layout": layout
  }, sections.slice(0, 8)?.map((section, idx) => {
    return /*#__PURE__*/_react.default.createElement(_waterfallItem.default, (0, _extends2.default)({
      key: idx
    }, section));
  })));
}
var _default = exports.default = WaterfallSection;
WaterfallSection.propTypes = {
  _name: _propTypes.default.string,
  sections: _propTypes.default.array,
  layout: _propTypes.default.oneOf(['default', 'reverse']),
  partial: _propTypes.default.string,
  ..._boxModelSize.marginProps,
  ..._boxModelSize.paddingProps,
  ..._index.default.propTypes
};